import { createCachedSelector } from 're-reselect';

import {
  createEntitiesIndexSelector,
  indexSelectorCacheKey,
} from '../../entities_index/selectors';

export const JOB_STATUS_FINISHED = 'FINISHED';
export const JOB_STATUS_FAILED = 'FAILED';
export const JOB_STATUS_READY = 'READY';
export const JOB_STATUS_STARTED = 'STARTED';
export const JOB_STATUS_WAITING = 'WAITING';
export const JOB_STATUS_ABORT_PENDING = 'ABORT_PENDING';
export const JOB_STATUS_ABORTED = 'ABORTED';
export const JOB_STATUS_SKIPPED = 'SKIPPED';
export const JOB_FINISHED_WITH_WARNING = 'FINISHED_WITH_WARNING';
export const JOB_STATUS_PAUSED = 'PAUSED';

export const JOB_COMPLETED_STATUSES_SET = new Set([
  JOB_STATUS_FINISHED,
  JOB_STATUS_SKIPPED,
  JOB_STATUS_ABORTED,
  JOB_STATUS_FAILED,
  JOB_FINISHED_WITH_WARNING,
]);

export const selectJobsByObjectId = createEntitiesIndexSelector(
  'jobs',
  'object_id',
);

export const selectIncompleteTransferJobByObjectId = createCachedSelector(
  selectJobsByObjectId,
  (jobs) =>
    jobs.find(
      (job) =>
        job.type === 'TRANSFER' && !JOB_COMPLETED_STATUSES_SET.has(job.status),
    ),
)(indexSelectorCacheKey);

export const selectStartedTranscodeJobsByObjectId = createCachedSelector(
  selectJobsByObjectId,
  (jobs) =>
    jobs.filter((job) => job.type === 'TRANSCODE' && job.status === 'STARTED'),
)(indexSelectorCacheKey);

export const selectFailedTranscodeJobsByObjectId = createCachedSelector(
  selectJobsByObjectId,
  (jobs) =>
    jobs.filter((job) => job.type === 'TRANSCODE' && job.status === 'FAILED'),
)(indexSelectorCacheKey);

export const selectMetadataFillingJobsByObjectId = createCachedSelector(
  selectJobsByObjectId,
  (jobs) => jobs.filter((job) => job.type === 'METADATA_FILLING'),
)(indexSelectorCacheKey);

// A stable primitive summarizing this object's metadata-filling jobs (id +
// status), suitable as a `useEffect` dependency: it only changes when a
// metadata-filling job appears/disappears or changes status, so churn from
// unrelated job writes does not re-trigger effects.
export const selectMetadataFillingJobsSignatureByObjectId =
  createCachedSelector(selectMetadataFillingJobsByObjectId, (jobs) =>
    jobs
      .map((job) => `${job.id}:${job.status}`)
      .sort()
      .join('|'),
  )(indexSelectorCacheKey);
